import request from '@/utils/request'
// 登录
export function invoiceLogin(data) {
  return request({
    url: "/invoice/elephantInvoice/login",
    method: "post",
    data
  });
}
// 责任人类型列表
export function getPersonInChargeType(data) {
  return request({
    url: "/invoice/elephantInvoice/getPersonInChargeType",
    method: "get",
    params:data
  });
}
// 组织类型
export function getOrgType(data) {
  return request({
    url: "/invoice/elephantInvoice/getOrgType",
    method: "get",
    params:data
  });
}
// 税务机关
export function getTaxCode(data) {
  return request({
    url: "/invoice/invoiceDic/getTaxCode",
    method: "get",
    params:data
  });
}
// 邮编
export function getZipCode(data) {
  return request({
    url: "/invoice/invoiceDic/getZipCode",
    method: "get",
    params:data
  });
}
// 纳税人类型
export function  getTaxPayerType(data) {
  return request({
    url: "/invoice/elephantInvoice/getTaxPayerType",
    method: "get",
    params:data
  });
}
// 获取税控设备类型列表
export function  getTaxDriverType(data) {
  return request({
    url: "/invoice/elephantInvoice/getTaxDriverType",
    method: "get",
    params:data
  });
}
// 保存开票信息
export function  taxSave(data) {
  return request({
    url: "/invoice/elephantInvoice/save",
    method: "post",
    data
  });
}

// 查询已保存的开票信息 by shopId
export function  getTaxInfoByShopId(shopId) {
  return request({
    url: `/invoice/elephantInvoice/get/${shopId}`,
    method: "get",
    params:{}
  });
}
// 实名二维码生成

// 查询已保存的开票信息 by shopId
export function  getInvoiceQrCode(data) {
  return request({
    url: `/invoice/elephantInvoice/invoiceQrCode`,
    method: "post",
    data
  });
}


// 查询需要开通的发票信息列表
export function  getInvoiceVerifyList(data) {
    return request({
      url: `/invoice/elephantInvoice/list`,
      method: "get",
      params:data
    });
  }
// 开通发票
export function  elephantInvoiceOpen(data) {
  return request({
    url: `/invoice/elephantInvoice/open`,
    method: "get",
    params:data
  });
}
  
///org/config/sb/list 数电发票控制-省办列表查询

export function  orgConfigSbList(data) {
  return request({
    url: `/invoice/org/config/sb/list`,
    method: "get",
    params:data
  });
}

//数电发票控制-地办列表查询
export function  orgConfigDbList(data) {
  return request({
    url: `/invoice/org/config/db/list`,
    method: "get",
    params:data
  });
}

//数电发票控制-采购控制-开闭控制
export function  orgConfigOperate(data) {
  return request({
    url: `/invoice/org/config/operate`,
    method: "put",
    data:data
  });
}